import { gql } from '@apollo/client';

// Lightweight query for the search/filter page — only fetches years and sources.
export const GET_WATER_USE_WATER_SYSTEM_YEARS_AND_SOURCES = gql`
    query getWaterUseSystemAnnualSourceData($pwsId: String!) {
        getWaterUseSystem(pwsId: $pwsId) {
            annualUseSelectionData {
                years
                sources {
                    id
                    name
                }
            }
        }
    }
`;

// Fetches system info and years/sources in a single request.
export const GET_WATER_USE_WATER_SYSTEM = gql`
    query getWaterUseSystem($pwsId: String!) {
        getWaterUseSystem(pwsId: $pwsId) {
            systemName
            assignedUser {
                umdId
                firstName
                lastName
            }
            cca
            ccaDate
            engReport
            fileNumber
            d2Link
            standardSet
            peakDayDemand
            averageAnnualDemand
            equalizationStorage
            annualUseSelectionData {
                years
                sources {
                    id
                    name
                }
            }
        }
    }
`;

export const GET_WATER_USE_WATER_SYSTEM_ANNUAL_USE = gql`
    query getWaterUseSystemAnnualUse($pwsId: String!, $years: [Int!]!, $sources: [String!]) {
        getWaterUseSystemAnnualUse(pwsId: $pwsId, years: $years, sources: $sources) {
            WaterUseSources {
                sourceId
                sourceName
                sourceStatus
                sourceType
                diversionType
                AnnualRecords {
                    recordYear
                    jan
                    feb
                    mar
                    apr
                    may
                    jun
                    jul
                    aug
                    sep
                    oct
                    nov
                    dec
                    total
                }
            }
            SystemAnnualUse {
                historyYear
                domesticUseACFT
                commercialUseACFT
                industrialUseACFT
                institutionalUseACFT
                totalUseACFT
                domesticUseGallons
                commercialUseGallons
                industrialUseGallons
                institutionalUseGallons
                totalUseGallons
                totalFromSourcesACFT
                totalWholesaleSourcesACFT
                totalReturnSourcesACFT
                nonRevenuePercent
                nonRevenueACFT
                nonRevenueGallons
            }
        }
    }
`;

// Fetches peak day and peak month demand in a single request.
export const GET_WATER_USE_WATER_SYSTEM_PEAK_DATA = gql`
    query getWaterUseSystemPeakData($pwsId: String!, $years: [Int!]!, $sources: [String!]) {
        getWaterUseSystemPeakData(pwsId: $pwsId, years: $years, sources: $sources) {
            peakDemand {
                historyYear
                peakDate
                peakDemandACFT
                peakDemandGallons
                peakUseInclude
                peakMeasurementType
                peakWholesaleVolumeACFT
                peakWholesaleVolumeGallons
            }
            peakMonthDemand {
                historyYear
                peakMonthDemandACFT
                peakMonthDemandGallons
                daysInMonth
                gallonsPerDay
            }
        }
    }
`;

export const GET_WATER_USE_ENGINEERS = gql`
    query getWaterUseEngineers {
        getWaterUseEngineers {
            umdId
            firstName
            lastName
        }
    }
`;

export const UPDATE_WATER_USE_SYSTEM = gql`
    mutation updateWaterUseSystem(
        $UpdateWaterUseSystemInput: UpdateWaterUseSystemInput!
    ) {
        updateWaterUseSystem(
            UpdateWaterUseSystemInput: $UpdateWaterUseSystemInput
        ) {
            assignedUser {
                umdId
                firstName
                lastName
            }
            cca
            ccaDate
            engReport
            fileNumber
            d2Link
            standardSet
            peakDayDemand
            averageAnnualDemand
            equalizationStorage
        }
    }
`;